// src/components/HomePage.js

import React from 'react';
import SearchBar from './SearchBar'

function HomePage() {
    return (
        <div className="home-container relative flex flex-col items-center justify-center h-auto pt-5 pb-1">
            <div className="relative flex justify-center items-center w-full">
                <div className="relative w-full h-auto sm:max-h-[500px] md:max-h-[800px] lg:max-h-[1000px] flex items-center justify-center">
                        <img src="/web_logo.png" alt="Cell Surface Map Logo"
                             className="logo w-[80%] max-w-[1000px] h-auto"/>
                </div>
            </div>

            <SearchBar className="home-page-search-bar flex items-center w-4/5 max-w-[1000px] mb-64 z-10" />

            {/* First Content Section */}
            <div className="content-section text-left max-w-5xl leading-7 flex justify-center py-16 md:py-24">
                <div className="content-inner-container grid grid-cols-1 md:grid-cols-2 gap-16">
                    <div className="text-container order-first md:order-last">
                        <h2 className="text-3xl md:text-5xl font-serif mb-4">
                            <span className="highlight">Cell Surface Map</span> provides distribution and
                            organization data on immune cell surface proteins.</h2>
                        <h3 className="text-2xl font-serif text-[#9b4819] mb-2">How It Works</h3>
                        <p className="text-base md:text-lg">The website consists of interactive visuals of the distribution and organization
                            of proteins on the Jurkat and
                            Daudi cell surface. This data is curated from 85 proximity labeling experiments that
                            identified the
                            proximal neighborhoods of proteins on the cell surface.</p>
                        <h6 className="text-2xl font-serif mt-8 text-[#9b4819]">Cell Surface Map provides surface protein
                            distributions for Jurkat and Daudi cells.</h6>
                    </div>
                </div>
            </div>

            {/* Second Content Section */}
            <div className="content-section second-section text-left max-w-5xl mx-auto leading-7 py-16 md:py-24">
                <div className="content-inner-container flex flex-col md:flex-row items-center gap-16">
                    <div className="video-container md:w-1/2 relative">
                        <div className="absolute inset-0 bg-[#f4f1e8] opacity-70 rounded-lg z-10"></div>
                        <video 
                            autoPlay 
                            loop 
                            muted 
                            playsInline
                            className="w-full h-auto rounded-lg shadow-lg relative"
                        >
                            <source src={process.env.PUBLIC_URL + '/videos/CD81_video_crop.mp4'} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="text-container md:w-1/2">
                        <h2 className="text-2xl md:text-4xl font-serif mb-4">For Citation</h2>
                        <p className="text-base md:text-lg mb-8">
                            If you use this resource, please cite the following paper...
                            <br/>
                            Floyd, Brendan, et al. "Mapping the Nanoscale Organization of the Human Cell Surface Proteome Reveals New Functional Associations and Surface Antigen Clusters."
                            <span className="italic"> bioRxiv</span>, Feb. 2025.
                        </p>
                        <h6 className="text-2xl text-[#9b4819] font-serif">
                            For more information, please visit the <a href="/about" className="text-blue-500">About</a> page.
                        </h6>
                    </div>
                </div>
            </div>

            {/* Third Content Section */}
            <div className="content-section third-section text-center py-16 md:py-24">
                <div className="contact-container">
                    <h1 className="text-3xl md:text-5xl font-serif mb-4">Contact</h1>
                    <p className="text-base md:text-lg">For questions, feedback, and inquiries, please contact Dr.
                        Brendan Floyd at bmfloyd@stanford.edu and Dr. Carolyn Bertozzi at bertozzi@stanford.edu.</p>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
